import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

import Home from "@/pages/Home";
import CriacaoSites from "@/pages/CriacaoSites";
import GoogleAds from "@/pages/GoogleAds";
import MetaAds from "@/pages/MetaAds";
import Avaliacoes from "@/pages/Avaliacoes";
import Contato from "@/pages/Contato";
import SiteProfissional from "@/pages/SiteProfissional";

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/criacao-de-sites" element={<CriacaoSites />} />
            <Route path="/google-ads" element={<GoogleAds />} />
            <Route path="/meta-ads" element={<MetaAds />} />
            <Route path="/avaliacoes" element={<Avaliacoes />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/site-profissional" element={<SiteProfissional />} />
            <Route path="/sites-a-partir-de-199" element={<SiteProfissional />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <FloatingWhatsApp />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
